import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { BoltDirectivesModule } from '@nationwide-bolt/ng-directives';
import { PolicySearchComponent } from './components/policy-search/policy-search.component';
import { PolicyFoundComponent } from './components/policy-found/policy-found.component';
import { PaymentComponent } from './components/payment/payment.component';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { ReviewPaymentDetailsComponent } from './components/review-payment-details/review-payment-details.component';
import { PaymentConfirmationComponent } from './components/payment-confirmation/payment-confirmation.component';
import { ViewPaymentDetailsComponent } from './components/view-payment-details/view-payment-details.component';
import { RecurringPaymentsComponent } from './components/recurring-payments/recurring-payments.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VersionComponent } from './components/version/version.component';
import { HideCharsPipe } from './models/display-mask.pipe';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { HttpClientModule } from '@angular/common/http';
import { NumericOnlyDirective } from './directives/numeric-only.directive';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LandingPageComponent,
    PolicySearchComponent,
    PolicyFoundComponent,
    PaymentComponent,
    PaymentMethodComponent,
    ReviewPaymentDetailsComponent,
    PaymentConfirmationComponent,
    ViewPaymentDetailsComponent,
    RecurringPaymentsComponent,
    VersionComponent,
    HideCharsPipe,
    NumericOnlyDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BoltDirectivesModule,
    NgxMaskDirective,
    NgxMaskPipe,
    HttpClientModule
  ],
  providers: [provideNgxMask()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
  exports:[HideCharsPipe]
})
export class AppModule { }
